<template>
  <div>
    <el-row :gutter="10" style="width: 100%">
      <el-col :span="24">
        <el-checkbox v-model="form.showToInfo" :label="t('carts.differentBuyer')" size="large" />
      </el-col>
      
      <el-col v-if="form.showToInfo" :xs="24" :sm="10" class="to-info mb-3">
        <el-form-item prop="to_name">
          <el-input-sanitize 
            v-model="form.to_name" 
            :disabled="!form.showToInfo"
            :placeholder="$t('收件人姓名')" 
            size="large" 
            maxlength="50" 
          />
        </el-form-item>
      </el-col>
      <el-col v-if="form.showToInfo" :xs="24" :sm="10" class="to-info mb-3">
        <el-form-item prop="to_mobile">
          <el-input-mobile 
            v-model="form.to_mobile" 
            :country="form.country" 
            :disabled="!form.showToInfo"
            :placeholder="$t('收件人手機')" 
            size="large"
            @input="(value) => form.to_mobile = value" 
          />
        </el-form-item>
      </el-col>

    </el-row>
    
  </div>
</template>

<script setup>
import { onMounted } from "vue"
import { useVModel } from "@vueuse/core";
import { useI18n } from "vue-i18n"
import ElInputSanitize from "./InputComponents/ElInputSanitize.vue";
import ElInputMobile from "./InputComponents/ElInputMobile.vue";

const props = defineProps({
  modelValue: Object,
});
const emit = defineEmits(["update:modelValue"]);

const { t, locale } = useI18n()
const form = useVModel(props, "modelValue", emit);

onMounted(() => {
  // console.warn("ToNameMobile onMounted", form.value.to_name, form.value.to_mobile);
  // if (!form.value.to_name && form.value.buyer_name) {
  //   form.value.to_name = form.value.buyer_name;
  // }
  // if (!form.value.to_mobile && form.value.buyer_mobile) {
  //   form.value.to_mobile = form.value.buyer_mobile;
  // }
})

</script>

<style lang="scss"></style>